<template>
  <page>
    <div>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 sm12 md12 lg12>
      <v-card>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12>
                <form ref="TXTForm">
                  <input type="file" style="display: none" ref="TXTfile" :accept="'.txt' || '.TXT'" @change="doValidateFile">
                </form>
                <v-text-field readonly
                 v-model="form.requestedFile" :label="labels.requestedFile" :error-messages="errors.collect('requestedFile')" data-vv-name="requestedFile" :data-vv-as="labels.requestedFile" append-icon="mdi-magnify" @click:append="pickFile" v-validate="'required'"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <v-spacer class="mt-3"></v-spacer>
                <v-flex xs12 sm12 md12 lg12>
                <v-container fluid grid-list-lg>
            <v-btn color="primary" dark class="mb-2" @click="doSend">
              <v-icon>mdi-upload</v-icon>
              Upload
            </v-btn>
          </v-container>
          </v-flex>
    </div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'

export default {
  data() {
    return {
      uploading: false,
      labels: {
        requestedFile: 'LTA Vehicle Registration & Chassis Change File'
      },
      form: {
        requestedFile: '',
        format: 'PDF'
      },
      textDataTransferObject: [],
      supportedFormat: []
    }
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        this.form.format = value[0].value
      }
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.underwriting.dataTransferSettings.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  methods: {
    async doInit() {
      const apiUrl = this.rptMenu.uploadChangeLtaVegNoInit
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          if (result.data) {
            const { data } = result.data
            if (data) {
              this.supportedFormat = data.format
              this.menu = extractMenu(result.data._links)
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.processing = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url. [uploadChangeLtaVegNoInit]')
      }
    },
    doValidateFile(e) {
      this.form.requestedFile = ''
      this.textDataTransferObject = []
      this.resetMessages()
      if (e.target.files[0]) {
        this.uploading = true
        const file = e.target.files[0]
        if (file.name.indexOf('.txt') !== -1 || file.name.indexOf('.TXT') !== -1) {
          this.form.requestedFile = file.name
          const fileReader = new FileReader()
          fileReader.readAsText(file)
          fileReader.onload = async () => {
            var lines = fileReader.result.split('\n')
            let countCaseC = 0
            let countCaseT = 0
            let detailLine = []
            let controlRecord = []
            let trailerRecord = []
            if (lines.length < 1) {
              this.$toast.error('No Line Is Found On The Text File Uploaded')
            } else {
              for (var line = 0; line < lines.length; line++) {
                // If User Uploaded a file with multiple control/trailer record
                if (countCaseC > 1) {
                  this.$toast.error('Multiple Control Record found!')
                  this.form.requestedFile = ''
                  this.textDataTransferObject = []
                  break
                }
                if (countCaseT > 1) {
                  this.$toast.error('Multiple Trailer Record found!')
                  this.form.requestedFile = ''
                  this.textDataTransferObject = []
                  break
                }
                switch (lines[line].substring(0, 1)) {
                  // As the JSON Object can held at maximum 100 characters in one element
                  // Split the element into 2 line, max 190 characters each line
                  case 'C':
                    controlRecord.push({
                      cTextLine: lines[line].substring(0, 100),
                      cTextLine2: lines[line].substring(100, 200)
                    })
                    countCaseC++
                    break
                  case 'T':
                    trailerRecord.push({
                      cTextLine: lines[line].substring(0, 100),
                      cTextLine2: lines[line].substring(100, 200)
                    })
                    countCaseT++
                    break
                  case 'D':
                    detailLine.push({
                      cTextLine: lines[line].substring(0, 100),
                      cTextLine2: lines[line].substring(100, 200)
                    })
                    break
                  default:
                    break
                }
              }
              this.textDataTransferObject.push({
                detailLine: detailLine,
                controlRecord: controlRecord,
                trailerRecord: trailerRecord
              })
            }
          }
        } else {
          this.$toast.error('Please Select Text File (.txt) Only!')
        }
      }
      this.uploading = false
      this.doUpload(e)
    },
    pickFile() {
      this.$refs.TXTForm.reset()
      this.$refs.TXTfile.click()
    },
    async getFile(event) {
      this.file = event.target.files[0]
    },
    async doUpload(event) {
      await this.getFile(event)
    },
    doSend() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.doPerformUpload()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPerformUpload() {
      const dto = []
      dto.push({
        requestedFileName: this.form.requestedFile,
        dataUploaded: this.textDataTransferObject,
        format: 'PDF',
        sendEmail: false
      })
      const apiURI = this.menu.upload
      if (apiURI) {
        this.uploading = true
        try {
          await this.$http.post(apiURI, dto[0])
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.uploading = false
      } else {
        this.$toast.error('Request Mapping Not Found!')
      }
    }
  },
  created() {
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>
